import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function RiskReversalSection() {
  return <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-343">
      <div className="max-w-2xl mx-auto" data-id="element-344">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-345">
          <div className="flex justify-center mb-6" data-id="element-346">
            <div className="w-16 h-16 rounded-full bg-[#0B6B3A]/10 flex items-center justify-center" data-id="element-347">
              <Shield className="w-8 h-8 text-[#0B6B3A]" data-id="element-348" />
            </div>
          </div>

          <h2 className="text-2xl sm:text-3xl font-bold text-[#1A1A1A] mb-4" data-id="element-349">
            Sin riesgo. Sin preguntas.
          </h2>

          <div className="bg-[#F9FAFB] border border-gray-200 rounded-2xl p-8 text-left space-y-4" data-id="element-350">
            <p className="text-base text-[#1A1A1A] leading-relaxed pt-[040px] pb-[040px]" data-id="element-351">
              Si abres el producto, lo revisás y sientes que no vale lo que
              pagaste, te devolvemos el dinero.
            </p>
            <p className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-352">
              Así de simples somos.
            </p>
            <p className="text-base text-[#6B7280] italic" data-id="element-353">
              Porque sabemos que cuando lo apliques en tu próximo chat, vas a
              querer mandárnoslo a nosotros también.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}